import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dashboard-wrapper page section py-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DashboardHeaderEdit = _resolveComponent("DashboardHeaderEdit")!
  const _component_DashboardGrid = _resolveComponent("DashboardGrid")!
  const _component_dashboard_add_widget_modal = _resolveComponent("dashboard-add-widget-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_DashboardHeaderEdit, {
      "onDashboardEdit:submit": _ctx.onSubmit,
      "onDashboardEdit:reset": _ctx.reset,
      "onDashboardEdit:addWidget": _ctx.addWidget
    }, null, 8 /* PROPS */, ["onDashboardEdit:submit", "onDashboardEdit:reset", "onDashboardEdit:addWidget"]),
    (_ctx.widgets)
      ? (_openBlock(), _createBlock(_component_DashboardGrid, {
          key: 0,
          ref: "edit-grid",
          "onGrid:change": _ctx.onGridChange,
          mode: _ctx.WidgetMode.EDIT,
          widgets: _ctx.widgets
        }, null, 8 /* PROPS */, ["onGrid:change", "mode", "widgets"]))
      : _createCommentVNode("v-if", true),
    _createVNode(_component_dashboard_add_widget_modal, {
      ref: "add-widget-modal",
      widgets: _ctx.widgets,
      onSubmitted: _ctx.updateWidgets
    }, null, 8 /* PROPS */, ["widgets", "onSubmitted"])
  ]))
}